import axios from "axios";

export class GuaranteesTableService {
    getGuaranteeTableData() {
        return axios.get('/appapv/getGuaranteeTableData.action', {})
            .then(res => res.data.payload);
    }

    updateAforoInstitution(objectAforo) {
        return axios.post('/appapv/updateAforoInstitution.action', {}, {
            params: {
                idInstitucionPTT: objectAforo.IdInstitucionPTT,
                idAforo: objectAforo.aforoObj.idTipoAforo,
            }
        }).then(res => {
            this.getGuaranteeTableData();
            return res.data;
        });
    }

    deleteAforoInstitution(objectAforo) {
        return axios.post('/appapv/deleteAforoInstitution.action', {}, {
            params: {
                idInstitucionPTT: objectAforo.IdInstitucionPTT,
            }
        }).then(res => {
            this.getGuaranteeTableData();
            return res.data;
        });
    }


}